import React, { useCallback, useEffect } from 'react';
import TranslatorManager from 'ts-translate-js';
import { TicketQtySelector } from './ticket-qty-selector';
import { FindTicketsResult } from '../../../mvcapi/models/buyticket/findticketsresult';
import { useAddTicketsToCartStore } from '../../../stores';
import './small-ticket-search.scss';
import { WaitSpinner } from '../../../../jsxctl/utilctl';
import { useAddPackageToCartStoreExt } from '../../../stores/add-to-cart-stores/add-package-to-cart-store-ext';
import { FindPackageTicketsResult } from '../../../mvcapi/models/buypackage/find-package-tickets-result';
import { useVenuePlanControl } from '../../../logic/hooks/use-venue-plan-control';
const tr = TranslatorManager.boundTR;

type SmallTicketSearchProps = {
    maxQty: number;
    limitQtySales: number;
    suggestedQtySales: number;
    internetTicketQTYMultipleOf: number;
    onContentChange?: Function;
}

export function SmallTicketSearch({maxQty, limitQtySales, suggestedQtySales, internetTicketQTYMultipleOf, onContentChange}: SmallTicketSearchProps) {
    const [searchTicketErrorMessage, setSearchTicketErrorMessage] = useAddTicketsToCartStore(s => [ s.searchTicketErrorMessage, s.setSearchTicketErrorMessage ]);
    const [eventDate] = useAddTicketsToCartStore(s => [s.eventDate]);
    //const addNewTickets = useAddTicketsToCartStore(s => s.addNewTickets);
    const [searchingTicket, setSearchingTicket] = useAddTicketsToCartStore(s => [ s.searchingTicket, s.setSearchingTicket ]);
    const [ticketQty, setTicketQty] = React.useState(suggestedQtySales || internetTicketQTYMultipleOf || 1);
    const [isAPackageSale, packageId, selectedEventDateIds] = useAddPackageToCartStoreExt(s => [s.isAPackageSale, s.packageId, s.selectedEventDateIds]);
    const addNewTickets = useAddTicketsToCartStore(s => s.addNewTickets);
    const addNewPackages = useAddPackageToCartStoreExt(s => s.addNewTickets);
    const planControl = useVenuePlanControl();
    
    useEffect(() => {
        if(onContentChange !== undefined) onContentChange();
    }, [suggestedQtySales, internetTicketQTYMultipleOf, onContentChange]);

    const handleOnQtyChange = useCallback((qty:number) => {
        setTicketQty(qty);
    }, [setTicketQty]);

    const afterFindTicketsSuccess = useCallback(async (result: FindTicketsResult | FindPackageTicketsResult) => {
        if(result.IsSuccess) {
            if(isAPackageSale()) {
                await addNewPackages(result.foundTickets);
            } else {  
                await addNewTickets(result.foundTickets);
            }

            if(result.foundTickets[0].Position)
                planControl.moveToXYZoomAtLeast({ x: result.foundTickets[0].Position.X, y: result.foundTickets[0].Position.Y }, 1, 1000); // In case of a package, Ticket [0] should be in our base event.
        } 
        else {
            setSearchTicketErrorMessage(result.message);   
        }
        setSearchingTicket(false);
    }, [setSearchingTicket, isAPackageSale, planControl, addNewPackages, addNewTickets, setSearchTicketErrorMessage]);

    const handleFindTickets = useCallback(async () => {
        setSearchingTicket(true);
        setSearchTicketErrorMessage("");

        if(!isAPackageSale()) {
            tsapp.svc.BuyTicket.findTickets(tsapp.mvcapi, eventDate.EventDateID, ticketQty, afterFindTicketsSuccess, 0, "", false);
        }
        else
            // TODO: Ramener le principe de recherche par section name pour les packages
            tsapp.svc.BuyTicket.findPackageTickets(tsapp.mvcapi, packageId, selectedEventDateIds, ticketQty, afterFindTicketsSuccess, null, false);

        
    }, [setSearchingTicket, setSearchTicketErrorMessage, isAPackageSale, packageId, selectedEventDateIds, ticketQty, afterFindTicketsSuccess, eventDate.EventDateID]);

    return <div className='small-ticket-search'>
        <div className='ticket-search '>
            <label>{tr("Trouvez-moi")}</label>
            <div className='ticket-qty-selector'>
                <TicketQtySelector
                    maxQty={maxQty}
                    limitQtySales={limitQtySales}
                    suggestedQtySales={suggestedQtySales}
                    internetTicketQTYMultipleOf={internetTicketQTYMultipleOf}
                    defaultValue={ticketQty}
                    onQtyChange={handleOnQtyChange}
                    onContentChange={onContentChange}
                />
            </div>
            <label>{isAPackageSale() ? tr("forfaits") : tr("billets")}</label>
            <div className='search-btn-container'>
                {searchingTicket ? <WaitSpinner />
                    : <button className='btn btn-primary form-inline-button' onClick={handleFindTickets}><i className="fas fa-search"></i></button>
                }
            </div>
        </div>
        {searchTicketErrorMessage && <div key="error" className="alert alert-danger">{tr(searchTicketErrorMessage)}</div>}
    </div>;
}
